@if (platformBrowser && gallery()) {
  <router-outlet></router-outlet>
  <div class="view-gallery-page" [class.dark]="theme().layout_page.background_color | isDarkColor">
    <div class="header-container">
      <app-preview-banner [gallery]="gallery()"></app-preview-banner>

      <app-view-gallery-header
        [gallery]="gallery()"
        [galleryPermissions]="galleryPermissions()"
        [mode]="'layout'"
        [theme]="theme()"
        (onFilterChange)="onFilter($event)"
        #header
      ></app-view-gallery-header>
    </div>

    @if (isBrowser) {
      <app-gallery [gallery]="gallery()" [sections]="sections$ | async" [noBottomPadding]="true" [filters]="filters()">
        <div class="gallery-footer-container">
          @if (noAssetsResult()) {
            <div class="no-results">
              <h3>No assets found</h3>
              <button
                (click)="resetFilter()"
                appButton
                color="default-opacity"
                name="reset-view-search-filter"
                location="view-gallery-page"
                shape="round"
                [center]="true"
              >
                Reset Filter
              </button>
            </div>
          }
          <div class="gallery-footer">
            <app-tenant-logo-and-contacts
              [tenant]="tenant()"
              [link]="['/']"
              [small]="true"
              [theme]="theme()"
            ></app-tenant-logo-and-contacts>
            @if (
              (!gallery() || tenant().picflow_branding_enabled) && gallery['tenant_product_name'] !== 'Picflow Free'
            ) {
              <app-made-with-picflow-button [tenantId]="tenant().id" [theme]="theme()"> </app-made-with-picflow-button>
            }
          </div>
        </div>
      </app-gallery>
    }
  </div>
  @if (gallery().approval_limits) {
    <app-approval-limit-info [gallery]="gallery()"></app-approval-limit-info>
  }
}
